import {
  UPLOAD_NEWS_IMAGE_SUCCESS,
} from 'actions/news';

export const newsImage = (previousState = {}, { type, payload }) => {
  if (type === UPLOAD_NEWS_IMAGE_SUCCESS) {
    return payload;
  }

  return previousState;
};


// WEBPACK FOOTER //
// ./src/reducers/news/index.js